import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { resendUserActivation } from '../../api/apis';
import { User } from '../../lib/interfaces/User';
import ProgressButton from '../Simple/ProgressButton/ProgressButton';

const ResendActivationButton = () => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [resendAttempts, setResendAttempts] = useState<number>(0);
	const { error, isSuccess, refetch } = useQuery<User, Error>(
		['resend-verification'],
		() => resendUserActivation(),
		{
			enabled: resendAttempts > 0,
			onError() {
				setIsLoading(false);
			},
			onSuccess() {
				setIsLoading(false);
			},
		},
	);
	const handleResend = () => {
		setIsLoading(true);
		setResendAttempts((prev) => prev + 1);
		if (refetch) {
			refetch();
		}
	};

	return (
		<div>
			{resendAttempts < 3 && (
				<>
					{!error && (
						<div style={{ margin: '10px 0' }}>
							<ProgressButton
								handleClick={handleResend}
								text={resendAttempts > 0 ? t('resendAgain') : t('resend')}
								isLoading={isLoading}
							/>
						</div>
					)}
					{isSuccess && (
						<Typography variant="body1" component="p">
							{t('resendSuccess')}
						</Typography>
					)}
					{error && (
						<Typography variant="body1" component="p" className="AuthModal__error">
							{error.message}
						</Typography>
					)}
				</>
			)}
			{resendAttempts >= 3 && (
				<Typography variant="body1" component="p" className="AuthModal__error">
					{t('resendLastAttempt')}
				</Typography>
			)}
		</div>
	);
};

export default ResendActivationButton;
